import { createAction } from "@reduxjs/toolkit"

export const getChartChargeWalletAsync = createAction(
   "chartChargeWallet/getChartChargeWalletDataAsync"
)

export const exportExcelChartChargeWalletAsync = createAction<any>(
   "chartChargeWallet/exportExcelChartChargeWalletAsync"
)
